// src/image.tsx
import { transformProps } from "@unpic/core";
function Image(props) {
  return <img {...transformProps(props)} />;
}

// src/source.tsx
import { transformSourceProps } from "@unpic/core";
function Source(props) {
  return <source {...transformSourceProps(props)} />;
}
export {
  Image,
  Source
};
